import React from "react";
import ReactDOM from "react-dom";
import WebFont from "webfontloader";

import "./styles/index.css";
import App from "./components/App";

import { Provider } from "react-redux";
import configureStore from "./store";

import * as serviceWorker from "./serviceWorker";

const store = configureStore();

WebFont.load({
  google: {
    families: ["Anton|Montserrat:200,400,600", "sans-serif"]
  }
});

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
